import { IterableElement } from 'type-fest'

import { SOLANA_TOKEN_TICKERS } from './token-tickers'
import { Ticker } from '../ticker'

export const SOLANA_TICKERS = [Ticker.SOL, ...SOLANA_TOKEN_TICKERS]

export type SolanaTicker = IterableElement<typeof SOLANA_TICKERS>
